import { UrlQueryMatchTypeEnum } from "../enums";
import { oldSystemUrlMappings } from "../mappers";
import { Log } from "./log.helpers";

const DEFAULT_OLD_PAGE = "/default.asp";
const mappings = oldSystemUrlMappings;

export const getOldSystemUrl = (path: string, query?: string): string => {
  const pathLower = path.toLowerCase();

  if (query) {
    const queryLower = query.toLowerCase();
    const matchExact = mappings.find(
      x =>
        x.sourcePath === pathLower &&
        x.sourceQueryMatchMode === UrlQueryMatchTypeEnum.PATH_AND_QUERY_EXACT &&
        queryLower === x.sourceQuery,
    );

    if (matchExact) {
      Log.debug(
        `Found match PATH_AND_QUERY_EXACT, path: ${path}, query: ${query}`,
      );
      return matchExact.targetPathAndQuery;
    }

    const matchStartWith = mappings.find(
      x =>
        x.sourcePath === pathLower &&
        x.sourceQueryMatchMode ===
          UrlQueryMatchTypeEnum.PATH_EXACT_QUERY_START_WITH &&
        queryLower.startsWith(query),
    );

    if (matchStartWith) {
      Log.debug(
        `Found match PATH_EXACT_QUERY_START_WITH, path: ${path}, query: ${query}`,
      );
      return matchStartWith.targetPathAndQuery;
    }

    const matchEndsWith = mappings.find(
      x =>
        x.sourcePath === pathLower &&
        x.sourceQueryMatchMode ===
          UrlQueryMatchTypeEnum.PATH_EXACT_QUERY_ENDS_WITH &&
        queryLower.endsWith(query),
    );

    if (matchEndsWith) {
      Log.debug(
        `Found match PATH_EXACT_QUERY_ENDS_WITH, path: ${path}, query: ${query}`,
      );
      return matchEndsWith.targetPathAndQuery;
    }

    const matchIncludes = mappings.find(
      x =>
        x.sourcePath === pathLower &&
        x.sourceQueryMatchMode ===
          UrlQueryMatchTypeEnum.PATH_EXACT_QUERY_INCLUDES &&
        queryLower.includes(query),
    );

    if (matchIncludes) {
      Log.debug(
        `Found match PATH_EXACT_QUERY_INCLUDES, path: ${path}, query: ${query}`,
      );
      return matchIncludes.targetPathAndQuery;
    }

    const matchByPathExactAnyQuery = mappings.find(
      x =>
        x.sourcePath === pathLower &&
        x.sourceQueryMatchMode ===
          UrlQueryMatchTypeEnum.BY_PATH_EXACT_ANY_QUERY,
    );

    if (matchByPathExactAnyQuery) {
      Log.debug(
        `Found match BY_PATH_EXACT_ANY_QUERY, path: ${path}, query: ${query}`,
      );
      return matchByPathExactAnyQuery.targetPathAndQuery;
    }
  }

  const matchByPathExactNoQuery = mappings.find(
    x =>
      x.sourcePath === pathLower &&
      x.sourceQueryMatchMode === UrlQueryMatchTypeEnum.BY_PATH_EXACT_NO_QUERY,
  );

  if (matchByPathExactNoQuery) {
    Log.debug(
      `Found match BY_PATH_EXACT_NO_QUERY, path: ${path}, query: ${query}`,
    );
    return matchByPathExactNoQuery.targetPathAndQuery;
  }

  const matchByPathStartWith = mappings.find(
    x =>
      x.sourcePath.startsWith(pathLower) &&
      x.sourceQueryMatchMode === UrlQueryMatchTypeEnum.BY_PATH_START_WITH,
  );

  if (matchByPathStartWith) {
    Log.debug(`Found match BY_PATH_START_WITH, path: ${path}, query: ${query}`);
    return matchByPathStartWith.targetPathAndQuery;
  }

  const matchByPathIncludes = mappings.find(
    x =>
      x.sourcePath.includes(pathLower) &&
      x.sourceQueryMatchMode === UrlQueryMatchTypeEnum.BY_PATH_INCLUDES,
  );

  if (matchByPathIncludes) {
    Log.debug(`Found match BY_PATH_INCLUDES, path: ${path}, query: ${query}`);
    return matchByPathIncludes.targetPathAndQuery;
  }

  Log.debug(`Not found match,using default, path: ${path}, query: ${query}`);
  return DEFAULT_OLD_PAGE;
};
